import { render, staticRenderFns } from "./dice.vue?vue&type=template&id=5847c182&scoped=true"
import script from "./dice.vue?vue&type=script&lang=js"
export * from "./dice.vue?vue&type=script&lang=js"
import style0 from "./dice.vue?vue&type=style&index=0&id=5847c182&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5847c182",
  null
  
)

export default component.exports